import React from "react";
import { X } from "lucide-react";

export default function ViewDrawer({ open, onClose, title, children, testid = "drawer" }) {
  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 bg-slate-900/30 backdrop-blur-sm z-40" onClick={onClose} data-testid={`${testid}-backdrop`} />
      <aside
        className="fixed top-0 right-0 h-full w-full max-w-xl bg-white shadow-2xl z-50 overflow-y-auto"
        data-testid={testid}
      >
        <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-[#0A1F44]" style={{ fontFamily: "'Segoe UI', 'Selawik', Tahoma, Geneva, Verdana, system-ui, sans-serif", fontWeight: 600, fontSize: "1.25rem" }}>
            {title}
          </h2>
          <button
            onClick={onClose}
            className="h-9 w-9 rounded-lg hover:bg-slate-100 flex items-center justify-center"
            data-testid={`${testid}-close`}
            aria-label="Close"
          >
            <X size={18} className="text-slate-600" />
          </button>
        </div>
        <div className="px-6 py-6">{children}</div>
      </aside>
    </>
  );
}
